var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('DenunciationsPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormDenunciationsPg',{attrs:{"loading":_vm.loading,"getDenunciationsPg":_vm.getDenunciationsPg},on:{"beforeUpdate":_vm.updateDenunciationsPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }